<template>
  <div id="app"></div>
</template>

<style>
</style>

<script>
export default {
  mounted() {    
    if (this._isMobile()) {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/mobile.html";
    } else {
      window.location.href =
        window.location.protocol + "//" + window.location.host + "/pc.html";
    }
  },
  methods: {
    _isMobile: function() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone"];
      var flag = false;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  }
};
</script>

